// English source strings of the Server Guardian section (decision D35) on the Observability & Audit page: status of the
// guardian, its last runs, the open incidents with their evidence and proposed fix, and the confirm actions.
// Merged into `en`; pt-BR lives in pt-BR-guardian.ts (complete, checked by the type).
export const enGuardian = {
  "guardian.title": "Server Guardian",
  "guardian.subtitle": "Watches the Coolify server where MaestrOS runs and the apps it published: crashes, failed deployments, dependency errors in logs, disk and memory.",
  "guardian.runNow": "Run now",
  "guardian.runQueued": "A guardian pass was queued; the worker runs it within a minute.",
  "guardian.runNeedsAdmin": "An organization admin runs the guardian on demand.",
  "guardian.workerOn": "Active on the worker: {n} Coolify connection(s) watched, every {minutes} min.",
  "guardian.workerOff": "Not active on the worker: no Coolify connection is in MAESTROS_ALLOW_REAL_COOLIFY_GUARDIAN, so nothing is read.",
  "guardian.workerUnknown": "No worker has reported the guardian yet.",
  "guardian.actionsOff": "Restart and redeploy are not sent: the connection is not in MAESTROS_ALLOW_REAL_COOLIFY_DEPLOY.",
  "guardian.lastRun": "Last run",
  "guardian.neverRun": "The guardian has not run yet.",
  "guardian.runSummary": "{when}: {services} service(s) checked, {findings} finding(s), {opened} new, {resolved} resolved.",
  "guardian.runError": "Failed: {error}",
  "guardian.runState.queued": "Queued",
  "guardian.runState.running": "Running",
  "guardian.runState.succeeded": "Finished",
  "guardian.runState.failed": "Failed",
  "guardian.incidents": "Open incidents",
  "guardian.noIncidents": "No open incidents: everything the guardian watches looks healthy.",
  "guardian.severity.critical": "Critical",
  "guardian.severity.high": "High",
  "guardian.severity.medium": "Medium",
  "guardian.severity.low": "Low",
  "guardian.service": "Service",
  "guardian.serviceKind.maestros": "MaestrOS",
  "guardian.serviceKind.published_app": "Published app",
  "guardian.serviceKind.server": "Server",
  "guardian.seen": "Seen {n} time(s), last {when}",
  "guardian.regressed": "Came back after being resolved",
  "guardian.evidence": "Evidence (redacted)",
  "guardian.cause": "Cause",
  "guardian.fix": "Proposed fix",
  "guardian.explainedByModel": "Explained by the guardian agent",
  "guardian.explainedByRules": "Explained by the detector rules",
  "guardian.fixKind.restart": "Restart the application (needs your confirmation)",
  "guardian.fixKind.redeploy": "Redeploy the application (needs your confirmation)",
  "guardian.fixKind.code_task": "Code change: a task builds, tests and reviews the fix",
  "guardian.fixKind.os_instructions": "Server packages or resources: follow the instructions on the VPS (never run by MaestrOS)",
  "guardian.openTask": "Open the fix task",
  "guardian.restart": "Restart",
  "guardian.redeploy": "Redeploy",
  "guardian.confirmRestart": "Restart {service}?",
  "guardian.confirmRedeploy": "Redeploy {service}?",
  "guardian.confirmBody": "The worker asks Coolify to do it (only when its connection is allowed to write). Requests in flight on that application may fail while it restarts. This action is audited.",
  "guardian.confirm": "Confirm",
  "guardian.actionRequested": "Requested; the worker sends it to Coolify within a minute.",
  "guardian.lastAction": "Last action: {action} — {state}",
  "guardian.actionState.requested": "waiting for the worker",
  "guardian.actionState.succeeded": "accepted by Coolify",
  "guardian.actionState.failed": "failed",
  "guardian.actionState.not_sent": "not sent",
  "guardian.actionsNeedAdmin": "An organization admin confirms restarts and redeploys.",
} as const;
